define('view/form/unit.finder.content.view',['require','exports','module','underscore','./base.finder.content.view','model/unit.model'],function(require, exports, module) {
  //prettier-ignore
  var _                     = require('underscore'),
      BaseFinderContentView = require('./base.finder.content.view'),
      UnitModel             = require('model/unit.model');

  var UnitFinderPreviewAnswerView = BaseFinderContentView.PreviewAnswerView.extend({
    options: _.extend({}, BaseFinderContentView.PreviewAnswerView.prototype.options, {
      type: 'Unit',
      modelClass: UnitModel,
      modalHeaderText: 'Unit Finder',
    }),

    internalViewOptions: BaseFinderContentView.PreviewAnswerView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          columns: [{ text: 'Name', data: 'name' }],
          emptyText: 'No Units have been selected.',
        };
      },
      addButtonView: function() {
        return {
          text: 'Find Unit',
        };
      },
    }),
  });

  var UnitFinderContentView = BaseFinderContentView.extend({
    internalViewOptions: BaseFinderContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: UnitFinderPreviewAnswerView,
        };
      },
    }),
  });

  module.exports = UnitFinderContentView;
});

